import React from 'react';
import { routes } from '../../../constants/config';

const ArchiveButton = ({ type, query }) => {
  const params = new URLSearchParams(window.location.search);
  return (
    <a
      className="Index-archiveLink NewButton NewButton--white NewButton--center undecorated mb-16"
      aria-label="View Archives Link"
      href={routes.ARCHIVES({
        type,
        query: params.get('query') || query,
      })}
    >
      {t('archive.view_archives')}
    </a>
  );
};

export default ArchiveButton;
